interface listen {
  <K extends keyof HTMLElementEventMap>(
    target: HTMLElement,
    type: K,
    listener: (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions,
  ): () => void;
  <K extends keyof WindowEventHandlersEventMap>(
    target: Window,
    type: K,
    listener: WindowEventHandlersEventMap[K],
    options?: boolean | AddEventListenerOptions,
  ): () => void;
  (
    target: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): () => void;
}

/** Listen to events on the target and return an unsubscribe function */
export const listen: listen = (
  target: EventTarget,
  type: string,
  listener: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions,
) => {
  target.addEventListener(type, listener, options);
  return () => target.removeEventListener(type, listener, options);
};
